import {Dispatch, FC, Fragment, SetStateAction, useEffect, useState} from 'react'
import {CustomInputs} from '../../../../../../../_metronic/helpers/components/CustomInputs'
import {isNotEmpty, onTSP} from '../../../../../../../_metronic/helpers'
import clsx from 'clsx'
import {Product} from '../../../../product-management/products-list/core/_models'

type props = {
  getPrice: () => number
  wage: {
    wage: string
    setWage: Dispatch<SetStateAction<string>>
    show?: boolean
    rate?: string
  }
  profit: {
    profit: string
    setProfit: Dispatch<SetStateAction<string>>
    show?: boolean
    rate?: string
  }
  commission: {
    commission: string
    setCommission: Dispatch<SetStateAction<string>>
    show?: boolean
    rate?: string
  }
  isOneRow?: boolean
  percentOf?: boolean
  onPercent?: boolean
  displayRates?: boolean
}

const Template3Fields: FC<props> = ({
  getPrice,
  wage,
  profit,
  commission,
  isOneRow = false,
  percentOf = true,
  onPercent = true,
  displayRates = false,
}) => {
  const labelWithRate = (label: string, rate?: string) =>
    displayRates && isNotEmpty(rate) ? `${label} (${rate}٪)` : label

  return (
    <Fragment>
      {wage.show != false && (
        <div className={clsx(isOneRow ? 'col-12' : 'col-xl-6 col-lg-12', 'mt-5')}>
          <CustomInputs
            isDisabled={getPrice() <= 0}
            type='currency'
            label={labelWithRate('اجرت ساخت', wage.rate)}
            percentOf={percentOf ? getPrice() : undefined}
            percentDefault={isNotEmpty(wage.rate) ? wage.rate : undefined}
            stateValue={{value: wage.wage, setValue: wage.setWage}}
            onPercent={onPercent}
          />
        </div>
      )}
      {profit.show != false && (
        <div className={clsx(isOneRow ? 'col-12' : 'col-xl-6 col-lg-12', 'mt-5')}>
          <CustomInputs
            isDisabled={getPrice() <= 0}
            type='currency'
            percentOf={percentOf ? getPrice() + Number(wage.wage) : undefined}
            percentDefault={isNotEmpty(profit.rate) ? profit.rate : undefined}
            label={labelWithRate('سود فروشنده', profit.rate)}
            stateValue={{value: profit.profit, setValue: profit.setProfit}}
            onPercent={onPercent}
          />
        </div>
      )}
      {commission.show != false && (
        <div className={clsx(isOneRow ? 'col-12' : 'col-xl-6 col-lg-12', 'mt-5')}>
          <CustomInputs
            isDisabled={getPrice() <= 0}
            type='currency'
            percentOf={percentOf ? getPrice() : undefined}
            percentDefault={isNotEmpty(commission.rate) ? commission.rate : undefined}
            label={labelWithRate('حق‌العمل', commission.rate)}
            stateValue={{value: commission.commission, setValue: commission.setCommission}}
            onPercent={onPercent}
          />
        </div>
      )}
      <div className={'col-12'} />
    </Fragment>
  )
}

export {Template3Fields}
